module.exports = __webpack_public_path__ + "static/work52-a16c79fa7ef9da29627bc6d0ec330729.jpg";